import { createSlice } from "@reduxjs/toolkit";
import { INotificationTypeSlice } from "../../../models/master/notification";

const initialNotificationTypeState: INotificationTypeSlice = {
    notificationTypes: undefined,
};

const notificationTypeSlice = createSlice({
    name: "notificationType",
    initialState: initialNotificationTypeState,
    reducers: {
        setNotificationType: (state, action: { payload: any }) => {
            state.notificationTypes = action.payload;
        },
    },
});

export const { setNotificationType } = notificationTypeSlice.actions;

const notificationTypeReducer = notificationTypeSlice.reducer;

export type notificationTypeState = ReturnType<typeof notificationTypeReducer>;

export default notificationTypeReducer;
